"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Declarations = exports.Kind = exports.Identifier = void 0;
const find_1 = require("./find");
const bind_1 = require("./bind");
const collect_1 = require("./collect");
var identifier_1 = require("./identifier");
Object.defineProperty(exports, "Identifier", { enumerable: true, get: function () { return identifier_1.Identifier; } });
var kind_1 = require("./kind");
Object.defineProperty(exports, "Kind", { enumerable: true, get: function () { return kind_1.Kind; } });
var Declarations;
(function (Declarations) {
    Declarations.collect = (abi) => {
        const unboundDeclarations = (0, collect_1.collectWithoutBindings)(abi);
        const declarations = (0, bind_1.bind)(unboundDeclarations);
        return declarations;
    };
    Declarations.find = find_1.find;
})(Declarations = exports.Declarations || (exports.Declarations = {}));
//# sourceMappingURL=index.js.map